module.exports = __webpack_public_path__ + "static/media/irestore.2074c805.png";